<h2 mat-dialog-title>{{ title }}</h2>
<div mat-dialog-content class="cp-select-dialog-content">
  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Search CPs</mat-label>
    <input matInput [formControl]="control" [matAutocomplete]="auto" placeholder="Type to search by number, system or subsystem" />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCp" (optionSelected)="selectCp($event.option.value)">
      @if (filteredCps$ | async; as list) {
        @for (cp of list; track cp.id) {
          <mat-option [value]="cp">
            <div class="cp-option">
              <div class="number">{{ cp.cpNumber || 'No number' }}</div>
              <div class="system" *ngIf="cp.system">{{ cp.system.name }}</div>
              <div class="subsystem" *ngIf="cp.subSystem">{{ cp.subSystem.name }}</div>
            </div>
          </mat-option>
        }
        @if (list.length === 0) {
          <mat-option disabled>No matching CPs</mat-option>
        }
      }
    </mat-autocomplete>
  </mat-form-field>

  @if (selectedCp) {
    <div class="selected-preview">
      <div class="title">Selected</div>
      <div class="card">
        <div class="initial">{{ (selectedCp.cpNumber || selectedCp.system?.name || 'C').charAt(0) }}</div>
        <div class="info">
          <div class="number">{{ selectedCp.cpNumber || 'Unnamed' }}</div>
          <div class="sys" *ngIf="selectedCp.system">{{ selectedCp.system.name }}</div>
          <div class="sub" *ngIf="selectedCp.subSystem">{{ selectedCp.subSystem.name }}</div>
        </div>
      </div>
    </div>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="!selectedCp" (click)="save()">Select</button>
</div>
